import _ from 'lodash';
import {connect} from 'react-redux';

import {SyncJobModel} from '../../../../../libs/shared/core/src/models/api/jobModel';
import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {getFlatCrmSyncs} from '../../../../store/data/crmSync/crmSyncsSelectors';
import {getAllSyncJobs} from '../../../../store/data/jobs/jobsSelectors';
import {CrmSyncErrorsBanner} from './crmSyncErrorsBanner';

/*
 * Props.
 */

interface CrmSyncErrorsBannerContainerProps {
  syncId: number;
}

/*
 * Selectors.
 */

function getSyncId(_state: AppState, props: CrmSyncErrorsBannerContainerProps) {
  return props.syncId;
}

function makeGetCrmSync() {
  return createSelector([getSyncId, getFlatCrmSyncs], (syncId, syncs) =>
    syncs.find((sync) => sync.id === syncId),
  );
}

function makeGetLatestJob() {
  return createSelector([getAllSyncJobs, getSyncId], (jobs: ReadonlyArray<SyncJobModel>, syncId) => {
    const latestJobForSync = _(jobs ?? [])
      .filter((job) => job.syncId === syncId)
      .reduce((a, b) => (a.createdAt < b.createdAt ? b : a));
    return latestJobForSync;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CrmSyncErrorsBannerContainerProps>()(() => ({
  crmSync: makeGetCrmSync(),
  latestJob: makeGetLatestJob(),
}));

export const CrmSyncErrorsBannerContainer = connect(mapStateToProps)(CrmSyncErrorsBanner);
